import React, { useState } from 'react';
import CodeScannerComponent from './CodeScanner';
import axios from 'axios';

const LinhaProduto = ({ item, onToggleRemovido, onQuantidadeChange }) => {
    const { produto, quantidade, removido } = item;

    // Define classes CSS e ícones com base no status 'removido'
    const trClassName = removido === 1 ? 'item-removido' : '';
    const buttonClassName = removido === 1 ? 'btn btn-success btn-sm' : 'btn btn-danger btn-sm';
    const iconClassName = removido === 1 ? 'bi bi-arrow-counterclockwise' : 'bi bi-trash';

    return (
        // Aplica a classe condicional na linha da tabela
        <tr data-id={produto.CODIGOBARRAS} className={trClassName}>
            <td data-label="Produto">
                <div className="fw-bold">{produto.DESCRICAO} ({produto.PARAMETRO1} {produto.PARAMETRO2})</div>
                <small className="text-muted">Cód: {produto.PRODUTO}</small>
            </td>
            <td data-label="Cód. Barras">
                <span className="font-monospace">{produto.CODIGOBARRAS}</span>
            </td>
            <td data-label="Quantidade">
                <input
                    type="number"
                    className="form-control form-control-sm"
                    value={quantidade}
                    min="1"
                    onChange={(e) => onQuantidadeChange(produto.CODIGOBARRAS, parseInt(e.target.value, 10) || 0)}
                    // Desabilita o input se o item estiver removido
                    disabled={removido === 1}
                />
            </td>
            <td data-label="Remover/Adicionar" className="text-end-desktop">
                {/* O botão agora usa as classes e o ícone dinâmicos */}
                <button className={buttonClassName} onClick={() => onToggleRemovido(produto.CODIGOBARRAS)}>
                    <i className={iconClassName}></i>
                </button>
            </td>
        </tr>
    );
}

const InventarioComponent = ({ catalogoProdutos = [], inventarioItens, inventarioId }) => {

    const processarInventarioItens = () => {
        return inventarioItens.map(item => {
            const { QUANTIDADEMOVIMENTADA, ...produtoInfo } = item;
            return {
                produto: produtoInfo,
                quantidade: QUANTIDADEMOVIMENTADA,
                removido: 0
            };
        });
    };

    const [produtosAdicionados, setProdutosAdicionados] = useState(processarInventarioItens);

    const handleScanResult = (codigoDeBarras) => {

        // Normaliza o código escaneado (remove zeros à esquerda)
        const codigoNormalizado = String(codigoDeBarras || '').replace(/^0+/, '');


        setProdutosAdicionados(prevProdutos => {
            const indexExistente = prevProdutos.findIndex(
                item => String(item.produto.CODIGOBARRAS || '').replace(/^0+/, '') === codigoNormalizado
            );

            // Se o produto já está na lista
            if (indexExistente !== -1) {
                const produtoAtualizado = {
                    ...prevProdutos[indexExistente],
                    quantidade: prevProdutos[indexExistente].quantidade + 1,
                    removido: 0
                };

                // Remove da posição antiga
                const novaLista = [...prevProdutos];
                novaLista.splice(indexExistente, 1);

                // Adiciona no topo
                return [produtoAtualizado, ...novaLista];
            }

            // Se não existe, procura no catálogo
            const produtoEncontrado = catalogoProdutos.find(
                p => String(p.CODIGOBARRAS || '').replace(/^0+/, '') === codigoNormalizado
            );

            if (produtoEncontrado) {
                return [
                    { produto: produtoEncontrado, quantidade: 1, removido: 0 },
                    ...prevProdutos
                ];
            } else {
                alert(`Produto com código "${codigoDeBarras}" não encontrado.`);
                return prevProdutos;
            }
        });
    };



    const handleQuantidadeChange = (codigoDeBarras, novaQuantidade) => {
        setProdutosAdicionados(prevProdutos =>
            prevProdutos.map(item =>
                item.produto.CODIGOBARRAS === codigoDeBarras
                    ? { ...item, quantidade: novaQuantidade }
                    : item
            )
        );
    };

    const handleToggleRemovido = (codigoDeBarras) => {
        setProdutosAdicionados(prevProdutos =>
            prevProdutos.map(item =>
                item.produto.CODIGOBARRAS === codigoDeBarras
                    ? { ...item, removido: item.removido === 1 ? 0 : 1 }
                    : item
            )
        );
    };

    // Envio dos dados para API
    const [salvando, setSalvando] = useState(false); // Estado de loading para o botão

    const handleSalvarInventario = async () => {
        setSalvando(true);

        // 1. Formata os dados do estado do React para o formato que o backend espera
        const payload = produtosAdicionados.map(item => {
            return {
                ...item.produto, // Espalha todas as propriedades do produto (PRODUTO, GRADE, IDINVENTARIOITEM, etc)
                quantidade: item.quantidade,
                removido: item.removido
            };
        });

        try {
            // 2. Envia os dados para o backend
            const response = await axios.post('/comercial/inventario/atualizarInventario', {
                inventario: inventarioId,
                inventarioItens: payload
            });

            alert(response.data);
            window.location.reload()

        } catch (error) {
            console.error("Erro ao salvar o inventário:", error);
            alert("Erro ao salvar: " + error.response?.data || error.message);
        } finally {
            setSalvando(false);
        }
    };

    return (
        <>
            <div className="my-4">
                <button
                    className="btn btn-success w-100 p-3"
                    onClick={handleSalvarInventario}
                    disabled={salvando}
                >
                    {salvando ? (
                        <>
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            <span> Salvando...</span>
                        </>
                    ) : 'Salvar Alterações no Inventário'}
                </button>
            </div>
            <div className="row g-4">
                {/* Coluna do Scanner */}
                <div className="col-lg-5">
                    <div className="card shadow-sm">
                        <div className="card-header"><h5 className="mb-0">Leitor de Código de Barras</h5></div>
                        <div className="card-body no-margin">
                            {/* Passamos a função de callback diretamente para o componente do scanner */}
                            <CodeScannerComponent onScanResult={handleScanResult} />
                        </div>
                    </div>
                </div>

                {/* Coluna da Lista de Produtos */}
                <div className="col-lg-7">
                    <div className="card shadow-sm">
                        <div className="card-header"><h5 className="mb-0">Produtos Registrados</h5></div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-striped table-hover align-middle table-vertical-mobile">
                                    <thead className="table-light">
                                        <tr>
                                            <th scope="col">Produto</th>
                                            <th scope="col">Cód. Barras</th>
                                            <th scope="col" style={{ width: 120 }}>Quantidade</th>
                                            <th scope="col" className="text-end">Remover/Adicionar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {produtosAdicionados.length > 0 ? (
                                            produtosAdicionados.map(item => (
                                                <LinhaProduto
                                                    key={item.produto.CODIGOBARRAS}
                                                    item={item}
                                                    onToggleRemovido={handleToggleRemovido}
                                                    onQuantidadeChange={handleQuantidadeChange}
                                                />
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="4" className="text-center text-muted py-4">Aguardando escaneamento...</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default InventarioComponent;